import { useContext } from "react";
import SnackbarContext from "context/snackbarContext";

function useSnackbar() {
  return useContext(SnackbarContext);
}

export default useSnackbar;
